/**
 *  UI-REFACTORED
 *    FROM --> ./legacy-web/src/main/js/awardFinder/resources/js/homePage/leaflet/mapUtil.js
 *    TO   --> ./webapps/shared-web/src/main/assets/js/home/award-finder/leaflet/map-util.js
 **/

var MapUtil = {};

MapUtil = (function () {

    var _map = null;
    var _pinClusterer = null;
    var _locations = []; // [{lat, long, data { airport, miles, upshow }}]
    var _homePin = null;
    var _markerFlight = null;
    var _markersClusterGroupUpsell = null;
    var _markersClusterGroupNoUpsell = null;
    var _markersClusterList = [];
    var _markersList = [];
    var _allInfoboxes = [];
    var _pinWidth = 20;
    var _pinHeight = 30;
    var _pinIconImage = '/awardFinder/resources/img/marker_blue_v1.png';
    var _pinIconImageUpsell = '/awardFinder/resources/img/marker_gray_v1.png';
    var _pinIconImageHome = '/awardFinder/resources/img/marker_home_v1.png';
    var _pinIconImageOrigin = '/content/images/travelInformation/Green_Flag.png';
    var _pinIconImageDestination = '/content/images/travelInformation/Red_Flag.png';
    var _pinIconShadowImage = '/awardFinder/resources/img/marker-shadow.png';
    var _whiteNumberedIcon = "/common/includes/gmapIcons/lightblue";
	var _darkNumberedIcon = "/common/includes/gmapIcons/darkblue";
	var _numberedIconExt = ".gif";
    var infoboxOffset = [-126, 30]; // x, y
    var upshowInfoboxOffset = [-126, 30]; // x, y
    var hoverInfoboxOffset = [20, -9]; // x, y

    var _originIcon = L.icon({
    	iconUrl: _pinIconImageOrigin,
    	iconSize:     [38, 38],
    	iconAnchor:   [17, 37],
    	popupAnchor:  [-5, -35]
    });

    var _destinationIcon = L.icon({
    	iconUrl: _pinIconImageDestination,
    	iconSize:     [38, 38],
    	iconAnchor:   [17, 37],
    	popupAnchor:  [-7, -35]
    });

    var _homeIcon = L.icon({
        iconUrl: _pinIconImageHome,
        shadowUrl: _pinIconShadowImage,
        iconSize:     [_pinWidth, _pinHeight], // size of the icon
        shadowSize:   [41, 41], // size of the shadow
        iconAnchor:   [5, 29], // point of the icon which will correspond to marker's location
        shadowAnchor: [5, 39],  // the same for the shadow
        popupAnchor:  [5, -27] // point from which the popup should open relative to the iconAnchor
    });

    var _upsellIcon = L.icon({
        iconUrl: _pinIconImageUpsell,
        shadowUrl: _pinIconShadowImage,
        iconSize:     [_pinWidth, _pinHeight], // size of the icon
        shadowSize:   [41, 41], // size of the shadow
        iconAnchor:   [5, 29], // point of the icon which will correspond to marker's location
        shadowAnchor: [5, 39],  // the same for the shadow
        popupAnchor:  [5, -27] // point from which the popup should open relative to the iconAnchor
    });

    var _noUpsellIcon = L.icon({
        iconUrl: _pinIconImage,
        shadowUrl: _pinIconShadowImage,
        iconSize:     [_pinWidth, _pinHeight], // size of the icon
        shadowSize:   [41, 41], // size of the shadow
        iconAnchor:   [5, 29], // point of the icon which will correspond to marker's location
        shadowAnchor: [5, 39],  // the same for the shadow
        popupAnchor:  [5, -27] // point from which the popup should open relative to the iconAnchor
    });

    var _flightIcon = null;

    function createMap(divMapName){
        _map = new L.Map(divMapName, {'zoomControl': false, 'minZoom': 2});
        osmTile = "//tile.openstreetmap.org/{z}/{x}/{y}.png";
        aaNewPageIcon = "<span aria-hidden='true' class='icon-newpage'></span>"
        aaNewPageText = "<span class='hidden-accessible'>" + AAcom.prototype.getProperty('newWindowTxt') + "</span>"
        osmCopyright = "&copy; <a id='openstreetmap' href='http://www.openstreetmap.org' target='_blank'>OpenStreetMap" + aaNewPageIcon + aaNewPageText + "</a> contributors";
        osmLayer = new L.TileLayer(osmTile, {maxZoom: 18, attribution: osmCopyright } );
        _map.addLayer(osmLayer);
        _map.addControl(L.control.zoom({position: 'topright'}));

    }

    function initializeMap() {
        createMap('award-view-map');
        createOriginMarker($('#originAirport .latitude').text(),
                $('#originAirport .longitude').text(), $('#originAirport .code').text());
        _map.fitBounds([[-46.431228, -143.291994],[64.460131, 129.196291]]);
        _map.on('zoomstart', function (e) { CommonUtil.showBackToAllResultsLink(); });

     }

    function initializeMapAirportLooup() {
        var coordinates = [18.299999237060547, -172.60000610351562, 71.69999694824219, -67.4000015258789];
        createMap('aa-airport-lookup-map-container');
        _map.fitBounds([[coordinates[0],coordinates[1]],[coordinates[2],coordinates[3]]]);

     }

    function initializeMapTrackFlight(divMapName, data) {
        createMap(divMapName);

        var markerOrigin = createMarker(data.airportOrigin.point.latitude, data.airportOrigin.point.longitude,_originIcon);
        markerOrigin.addTo(_map).bindPopup("<b>Airport Origin</b><br/>("+data.airportOrigin.code+") - "+data.airportOrigin.cityName);

        var markerDestination = createMarker(data.airportDestination.point.latitude, data.airportDestination.point.longitude,_destinationIcon);
        markerDestination.addTo(_map).bindPopup("<b>Airport Destination</b><br/>("+data.airportDestination.code+") - "+data.airportDestination.cityName);

        fetchFlightImage(data);
        _markerFlight = createMarker(data.flight.point.latitude, data.flight.point.longitude,_flightIcon);
        _markerFlight.addTo(_map).bindPopup("<b>Flight</b><br/>("+data.flight.carrierCode+") - "+data.flight.flightNumber);


		_map.fitBounds([[data.airportOrigin.point.latitude, data.airportOrigin.point.longitude],
		                [data.airportDestination.point.latitude, data.airportDestination.point.longitude],
		                [data.flight.point.latitude, data.flight.point.longitude]]);
	}

    function addPushPin(airportList){

    	clearMarkers();

    	var bounds = []
    	for(var i=0; i<airportList.length; i++){
    		var icon = L.icon({
        		iconUrl : _whiteNumberedIcon + (i+1) + _numberedIconExt,
        		iconSize:     [30, 30],
        		iconAnchor:   [3, 28],
        		popupAnchor:  [5, -30]
        	});
    		var marker = createMarker(airportList[i].latitude, airportList[i].longitude,icon);
            marker.addTo(_map).bindPopup(airportList[i].code +" - "+airportList[i].name);
            marker.airportCode = airportList[i].code;
            marker.on("click", function() {
            	setAirportCode(this.airportCode);
            });
            marker.on('mouseover', function(e) {
                this.openPopup();
            });
            marker.on('mouseout', function(e) {
                this.closePopup();
            });
            _markersList.push(marker);
            bounds.push([airportList[i].latitude, airportList[i].longitude]);
    	}

    	_map.fitBounds(bounds);

    	if(_map.getZoom() > 8){
    		_map.setZoom(8);
    	}
    }

    function refreshMapTrackFlight(data){
    	_markerFlight.setLatLng(L.latLng(data.flight.point.latitude, data.flight.point.longitude));
    }

    function fetchFlightImage(data) {
    	var flightLatitude = data.flight.point.latitude;
    	var flightLongitude = data.flight.point.longitude;
		var destinationMapLatitude = data.airportDestination.point.latitude;
		var destinationMapLongitude = data.airportDestination.point.longitude;
		var direction = DisplayBearing(calculateBearing(flightLatitude, flightLongitude,
    			destinationMapLatitude, destinationMapLongitude));
		var urlFlightImage = "/content/images/travelInformation/Flight_"+direction+".png";

    	_flightIcon = L.icon({
    		iconUrl : urlFlightImage,
    		iconSize:     [74, 74],
    		iconAnchor:   [30, 73],
    		popupAnchor:  [5, -50]
    	});
    }

    function DisplayBearing(brng) {
    	var disp = "";
    	if ((brng > 22.6) && (brng <= 67.7)) {
    		disp = "NE";
    	} else {
    		if ((brng > 67.7) && (brng <= 112.5)) {
    			disp = "E";
    		} else {
    			if ((brng > 112.5) && (brng <= 157.4)) {
    				disp = "SE";
    			} else {
    				if ((brng > 157.4) && (brng <= 202.5)) {
    					disp = "S";
    				} else {
    					if ((brng > 202.5) && (brng <= 247.4)) {
    						disp = "SW";
    					} else {
    						if ((brng > 247.4) && (brng <= 292.5)) {
    							disp = "W";
    						} else {
    							if ((brng > 292.5) && (brng <= 337.4)) {
    								disp = "NW";
    							} else {
    								disp = "N";
    							}
    						}
    					}
    				}
    			}
    		}
    	}
    	return disp;
    }

    function calculateBearing(flightLatitude, flightLongitude,
    		destinationMapLatitude, destinationMapLongitude) {
    	var lat1 = DegtoRad(flightLatitude);
    	var lon1 = flightLongitude;
    	var lat2 = DegtoRad(destinationMapLatitude);
    	var lon2 = destinationMapLongitude;
    	var dLon = DegtoRad(lon2 - lon1);
    	var y = Math.sin(dLon) * Math.cos(lat2);
    	var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2)
    			* Math.cos(dLon);
    	var brng = (RadtoDeg(Math.atan2(y, x)) + 360) % 360;
    	return brng;
    }

    function DegtoRad(x) {
    	return x * Math.PI / 180;
    }

    function RadtoDeg(x) {
    	return x * 180 / Math.PI;
    }

    function createOriginMarker(lat, lon, popupText) {
    	if(!(lat == undefined || lon == undefined || lat == "" || lon == "" || lat == null || lon == null)) {
	    	_homePin = createMarker(lat, lon, _homeIcon);
	    	_homePin.bindPopup(popupText);
	    	_homePin.addTo(_map);
    	}
    }

    function createMarker(lat, lon, icon) {
        return L.marker([lat, lon], {icon: icon});
    }

    function createMarker(lat, lon, icon, text) {
        return L.marker([lat, lon], {icon: icon, title: text});
    }

    function createResultMarker(airport, miles, upshow) {
        var lat = airport.point.latitude;
        var lon = airport.point.longitude;

        _locations.push({
            'latitude': lat,
            'longitude': lon,
            'data': {
                'airport': airport,
                'miles': miles,
                'upshow': upshow
            }});

    }

    function removeOriginMarker() {
        if(_homePin !== null) {
            _map.entities.remove(_homePin); // remove and add again, so it is on top
        }
    }

    function clearAllMarkers() {
        clearClustering();
         _locations = [];
    }

    function closeAllInfoboxes() {
        if (_allInfoboxes) {
            for (var i = 0; i < _allInfoboxes.length; i++) {
                _allInfoboxes[i].setOptions({
                    visible: false
                });
            }
        }
    }

    function panAndShowInfobox(code) {

        var loc = getLocation(code);
        var mmLoc = new L.LatLng(loc.latitude, loc.longitude);
        if(loc === undefined) {
            _log('could not find ' + code);
            return;
        }
        _map.setView([loc.latitude,loc.longitude], 8);

        var infobox = getInfoBox(code);
        if(infobox !== undefined) {
        	infobox.openPopup();
        }
    }

    function getClusterHoverInfoBoxHtml(numOfAirports, miles) {
        var milesComma = CommonUtil.commaSeparateNumber(miles);
        return numOfAirports + " " + AAcom.prototype.getProperty('resultsNearbyPreTxt') + " " + milesComma + " " + AAcom.prototype.getProperty('resultsNearbyPostTxt');
    }

    function getHoverInfoBoxHtml(airport, miles) {
        var milesComma = CommonUtil.commaSeparateNumber(miles);
        return airport.cityName +" (" + airport.code + ") - " + AAcom.prototype.getProperty('flyHerePreTxt') + " " + milesComma + " " + AAcom.prototype.getProperty('flyHerePostTxt');
    }

    function getInfoBox(code) {
        return _markersClusterList[code.toUpperCase()];
    }

    function zoomToShowAllResults() {
        closeAllInfoboxes();
        fitToMarkers();
    }

    function resetMap() {
        closeAllInfoboxes();
        clearAllMarkers();
    }

    function fitToMarkers() {
        if(_locations.length > 1) {
            _map.fitBounds(getBounds());

            if(_map.getZoom() > 8){
            	_map.setZoom(8);
        	}
        }
        else if(_locations.length == 1){
            var loc = _locations[0];
            map.setView([loc.latitude, loc.longitude], 5);
        }
    }

    function getLocation(code) {
        for(var i=0;i<_locations.length;i++) {
            if(_locations[i].data.airport.code == code) {
                return _locations[i];
            }
        }
    }

    function getPinCount() {
        return _locations.length;
    }

    function removeOriginMarker() {
        if(_homePin !== null) {
            _map.remove(_homePin); // remove and add again, so it is on top
        }
    }

    function updateOriginMarker(lat, lon, name, code) {
        if(lat !== undefined && lon !== undefined) {
            if(_homePin !== null) {
                _homePin.setLatLng(new L.LatLng(lat, lon)).update();
                _homePin.bindPopup('('+code+') - '+ name);
            } else {
            	createOriginMarker(lat, lon, '('+code+') - '+ name);
            }
        }
    }

    function addResultsToMap(airports) {
        /*
         * add to map from north to south so bottoms of pins are behind tops of
         * pins
         */
        airports.sort(function(a,b) {
            return b.airport.point.latitude - a.airport.point.latitude;
        });

        for(var i=0; i<airports.length; i++) {
            var airport = airports[i];
            createResultMarker(airport.airport, airport.miles, airport.upshow);
        }
        cluster(); // init clustering
        fitToMarkers();
    }

    function cluster() {

        initClustering(true);
        initClustering(false);
        _markersClusterList=[];

        for (var i = 0; i < _locations.length; i++) {
            var p = _locations[i];
            var titleC = getInfoBoxHtml(p.data.airport, p.data.miles, p.data.upshow);
            var titleO = getHoverInfoBoxHtml(p.data.airport, p.data.miles, p.data.upshow);

            var marker = createMarker(p.latitude, p.longitude,p.data.upshow ? _upsellIcon: _noUpsellIcon, titleO);
            marker.bindPopup(titleC);

            marker.miles = p.data.miles;
            _markersClusterList[p.data.airport.code] = marker;


            if(p.data.upshow){
            	_markersClusterGroupUpsell.addLayer(marker);
            }else{
            	_markersClusterGroupNoUpsell.addLayer(marker);
            }
        }

        _map.addLayer(_markersClusterGroupUpsell);
        _map.addLayer(_markersClusterGroupNoUpsell);
        _map.fitBounds(getBounds());

        if(_map.getZoom() > 8){
        	_map.setZoom(8);
    	}
    }

     function initClustering(isUpsell){

    	var markersClusterGroup = isUpsell ? _markersClusterGroupUpsell : _markersClusterGroupNoUpsell;
        clearClustering(markersClusterGroup);

        var clusterClassName = isUpsell?'leaflet-clustering-upsell-':'leaflet-clustering-no-upsell-';
        markersClusterGroup = L.markerClusterGroup({
        	maxClusterRadius: 20,
            chunkedLoading: true,
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            zoomToBoundsOnClick: false,
            iconCreateFunction: function(cluster) {
            	var clusterSize = "normal";
                if (cluster.getChildCount() >= 10) {
                    clusterSize = "small";
                }
                return L.divIcon({
                    html: '<div class="'+ clusterClassName  + clusterSize +'">' + cluster.getChildCount() + '</div>'
                })
            }
        });

        markersClusterGroup.on('clusterclick', function (a) {
            a.layer.zoomToBounds();
        });

        markersClusterGroup.on('clustermouseover', function (a) {
            var lowestMiles = a.layer.getAllChildMarkers()[0].miles;
            for(var i=1; i<a.layer.getChildCount(); i++) {
                if(lowestMiles > a.layer.getAllChildMarkers()[i].miles) {
                    lowestMiles = a.layer.getAllChildMarkers()[i].miles;
                }
            }
            a.layer._icon.title = getClusterHoverInfoBoxHtml(a.layer.getChildCount(), lowestMiles);
        });

        if(isUpsell){
        	_markersClusterGroupUpsell = markersClusterGroup;
        } else {
        	_markersClusterGroupNoUpsell = markersClusterGroup;
        }
    }

     function clearMarkers() {
		 for(var i=0;i<_markersList.length;i++) {
		     _map.removeLayer(_markersList[i]);
	     }
		 _markersList = [];
	 }

    function clearClustering(markersClusterGroup){
        if(markersClusterGroup!=null){
            markersClusterGroup.removeLayers(_markersClusterList);
            _map.removeLayer(markersClusterGroup);
        }
    }

    function getBounds() {
        var bounds=[];
        for (var i = 0; i < _locations.length; i++) {
            var p = _locations[i];
            bounds.push([p.latitude, p.longitude]);
        }
        return bounds;
    }

    function getInfoBoxHtml(airport, miles, upshow) {
        var milesComma = CommonUtil.commaSeparateNumber(miles);
        var $infoboxPrototype = $('#infobox-dummy').clone();
        $infoboxPrototype.find('.infobox').attr('id', 'infobox-' + airport.code);
        $infoboxPrototype.find('.destination').text(airport.code);
        var countryText = (airport.countryName == 'United States') ? airport.stateName : airport.countryName;
        
        if(airport.countryName === '' || airport.countryName.includes('Hong Kong') || airport.countryName.includes('Taiwan') || airport.countryName.includes('Macau')) {
            $infoboxPrototype.find('.title').text(airport.cityName + ' (' + airport.code + ')');
        } else {
            $infoboxPrototype.find('.title').text(airport.cityName + ', ' + countryText + ' (' + airport.code + ')');
        }
        $infoboxPrototype.find('.content').text(milesComma + ' ' + AAcom.prototype.getProperty('milesTxt'));
        /* display buy miles instead of book now */
        if(CommonUtil.displayBuyMiles(miles, upshow)) {
            $infoboxPrototype.find('a.book-now-map').hide();
            $infoboxPrototype.find('.buy-miles-map-container').show();
            $infoboxPrototype.find('.infobox').addClass('buy-miles-box');
        } else {
            $infoboxPrototype.find('a.book-now-map').attr('href', $('div.row-' + airport.code).find('a.book-now').attr('href'));
        }
        return $infoboxPrototype.html();
    }

    /**
     * public functions
     */
    return {
        initializeMap: initializeMap,
        initializeMapTrackFlight: initializeMapTrackFlight,
        initializeMapAirportLooup: initializeMapAirportLooup,
        refreshMapTrackFlight: refreshMapTrackFlight,
        addResultsToMap : addResultsToMap,
        updateOriginMarker: updateOriginMarker,
        removeOriginMarker : removeOriginMarker,
        panAndShowInfobox: panAndShowInfobox,
        addPushPin: addPushPin,
        resetMap: resetMap,
        clearMarkers: clearMarkers,
        zoomToShowAllResults: zoomToShowAllResults,
        _pinClusterer : _pinClusterer,
        getPinCount: getPinCount
    };
}());
